import { motion } from 'motion/react';
import { FunctionComponent } from 'react';
import { adaptTransition, AsyncAnimationProps, directed } from '../../util/Animation';
import { Log } from '../../util/Logging';
import { GameBoardZIndex } from './GameBoardZIndex';

type BackgroundDimProps = AsyncAnimationProps & {
	reverse?: boolean;
};

export const BackgroundDim: FunctionComponent<BackgroundDimProps> = (props) => {
	const opacity = directed({ from: 0, to: 1 }, props);

	Log.ui.debug('BackgroundDim.render', props);

	return props.show && <motion.div
		initial={{ opacity: opacity.from }}
		animate={{ opacity: opacity.to }}
		transition={adaptTransition({ duration: 2 })}
		onAnimationComplete={props.onComplete}
		style={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundImage: 'radial-gradient(ellipse 60% 40% at 50% 100%, #c2bb00c0 0%, rgba(0, 0, 0, 0.8) 100%)',

			zIndex: GameBoardZIndex.Dim,
			pointerEvents: 'none',
		}}
	/>;
};
